import '@/app/app.css';
import './contacts.css';

import '@/app/app';
import '@/layouts/main/main';

window.addEventListener('DOMContentLoaded', () => {

});